import { get as _get } from 'lodash-es';
import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import type { City } from '../../types/City';
import ConfirmButton from '../confirm-button';
import { makeCityPrimaryMutation } from '../../apollo/cities';
import { useAppContext } from '../../contexts/app';

type Props = {
  city?: City;
};

const CityPrimaryToggle = ({ city }: Props) => {
  const { loggedInUser } = useAppContext();
  const [makeCityPrimary] = useMutation(makeCityPrimaryMutation);

  const handleClick = useCallback((e) => {
    e.preventDefault();
    makeCityPrimary({
      variables: { id: city.id }
    });
  }, [city, makeCityPrimary]);

  if (!loggedInUser) {
    return null;
  }

  if (city.id === _get(loggedInUser, 'primaryCity.id')) {
    return null;
  }

  return (
    <ConfirmButton
      label="Switch To City"
      confirmMessage={`Are you sure you want to change your primary city to ${city.name}?`}
      variant="outlined"
      color="primary"
      onClick={handleClick}
    />
  );
};

export default CityPrimaryToggle;
